const cityRoutes = {
    weather: "/city/weather",
    fishSpots: "/city/fish-spots",
    suggestedSpots: "/city/suggested-spots"
};


export {cityRoutes};